import { useEffect } from "react";
import { Button, Typography } from "antd";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { triggerUnifiedResize, useIsUnifiedMode } from "@/shared/utils";
import { ObjectFormRadio } from "..";
import { FormType } from "../../types/form-type";
import { ObjectFormPermissionsBlock } from "./object-form-permissions-block";

export function ObjectFormPermissions() {
  const { register, control, getValues, setValue } = useFormContext<FormType>();
  const isUnifiedMode = useIsUnifiedMode();

  const required = useWatch<FormType>({
    control,
    name: "permissions.required",
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "permissions.documentationPermissions",
  });

  useEffect(() => {
    if (required && fields?.length < 1) {
      append({});
    }
  }, [required, fields.length, append]);

  useEffect(() => {
    register("deletedPermissions");
  }, [register]);
  const handleAddPermission = () => {
    append({});
    if (isUnifiedMode) {
      triggerUnifiedResize();
    }
  };

  const removeLocal = (index:number) => {
    // If removing an existing permission, track it in deletedPermissions set
    const id = getValues(
      `permissions.documentationPermissions.${index}.documentationPermissionId` as const,
    ) as string | undefined;
    if (id) {
      const current = (getValues("deletedPermissions") as Set<string> | undefined) || new Set<string>();
      const next = new Set(current);
      next.add(id);
      setValue("deletedPermissions", next);
    }
    remove(index);
  };


  return (
    <div className="form-section form-body">
      <Typography.Title level={5} style={{ margin: 0 }}>
        Разрешение на строительство
      </Typography.Title>
      <ObjectFormRadio
        name="permissions.required"
        control={control}
        radioOptions={[
          { title: "Требуется", value: true },
          { title: "Не требуется", value: false },
        ]}
      />
      {required && (
        <>
          <div>
            Заполняется если разрешение на строительство требуется в
            соответствии со ст. 51 Градостроительного кодекса РФ
          </div>
          {fields.map((field, index) => (
            <ObjectFormPermissionsBlock
              remove={removeLocal}
              availableToRemove={!required || fields.length > 1}
              index={index}
              key={field.id}
            />
          ))}
          <Button
            type="dashed"
            style={{
              width: "fit-content",
              backgroundColor: "#EAEEF8",
            }}
            onClick={handleAddPermission}
          >
            Добавить еще разрешение на строительство
          </Button>
        </>
      )}
    </div>
  );
}
